/**
 * Mixed by Nasrin — <gallery-dots>
 * -----------------------------------------------------------------------
 * Pagination dots for the mobile PDP media slider. Reads scroll position
 * off the existing Dawn slider; does not touch SliderComponent or
 * MediaGallery, so variant swaps and the lightbox keep working as before.
 *
 * Usage: place inside <slider-component>, after the <ul class="slider">.
 *   <gallery-dots class="quick-add-hidden"></gallery-dots>
 *
 * 2026-08-15: active slide is resolved by nearest offsetLeft rather than
 * dividing scrollLeft by the container width. Slides are narrower than the
 * track whenever --mixed-peek is non-zero, so the division approach drifts
 * and the wrong dot lights up partway through the gallery. offsetLeft is
 * correct for any slide width, peek, or gap.
 */
(function () {
  if (customElements.get('gallery-dots')) return;

  class GalleryDots extends HTMLElement {
    connectedCallback() {
      // Wait a frame so layout has settled and hidden variant slides
      // report a real width.
      requestAnimationFrame(() => this.init());
    }

    init() {
      const component = this.closest('slider-component');
      this.slider = component && component.querySelector('ul.slider');
      if (!this.slider) return;

      this.slides = Array.from(this.slider.querySelectorAll('.slider__slide')).filter(
        (slide) => slide.offsetWidth > 0
      );

      if (this.slides.length < 2) {
        this.hidden = true;
        return;
      }

      this.render();

      this.ticking = false;
      this.slider.addEventListener(
        'scroll',
        () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.setActive();
            this.ticking = false;
          });
        },
        { passive: true }
      );

      this.setActive();
    }

    render() {
      this.innerHTML = this.slides
        .map(
          (_, i) =>
            `<button type="button" class="gallery-dots__dot" aria-label="Go to image ${i + 1}"></button>`
        )
        .join('');

      this.dots = Array.from(this.children);

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.slider.scrollTo({ left: this.slides[i].offsetLeft, behavior: 'smooth' });
        });
      });
    }

    setActive() {
      const scrollLeft = this.slider.scrollLeft;

      let index = 0;
      let closest = Infinity;

      for (let i = 0; i < this.slides.length; i++) {
        const distance = Math.abs(this.slides[i].offsetLeft - scrollLeft);
        if (distance < closest) {
          closest = distance;
          index = i;
        }
      }

      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  }

  customElements.define('gallery-dots', GalleryDots);
})();
